import type { Pixel, Rectangle } from "@pdfking/math"

export type ImageArray = {
  readonly data: Uint8Array
} & Rectangle<Pixel>
